module.exports = __webpack_public_path__ + "static/media/myflogo-rrhh.070f31af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/myflogo-rrhh.png
// module id = 1102
// module chunks = 0